import { Booking, SessionStatus } from '../../core/models/booking';
import { extractMessageFromError } from '../../infra/adapters/luminara/common/ErrorUtil';

export type ClientFeedbackFormStatus = 'not-submitted' | 'started' | 'submitted' | 'skipped';

export interface MeetingState {
  meetingInitialized: boolean;
  loadingDataErrors: string[];
  sessionStatus: SessionStatus;
  bookedTime?: Date;
  roomJoined: boolean;
  bookingId?: string;
  healerPictureSrc?: string;
  clientPictureSrc?: string;
  healerInitials?: string;
  clientInitials?: string;
  healerFirstName?: string;
  healerLastName?: string;
  clientFirstName?: string;
  clientLastName?: string;
  clientId?: string;
  healerId?: string;
  clientFeedbackFormStatus: ClientFeedbackFormStatus;
}

export const initialMeetingState = () => {
  return {
    meetingInitialized: true,
    sessionStatus: 'STARTED',
    roomJoined: false,
    loadingDataErrors: [],
    clientFeedbackFormStatus: 'not-submitted',
  } as MeetingState;
};
export interface MeetingAction {
  type:
    | 'SET_MEETING_INITIALIZED'
    | 'LOAD_BOOKING_SUCCESS'
    | 'LOAD_BOOKING_FAILURE'
    | 'MARK_AS_FINISHED'
    | 'MARK_AS_MEETING_IN_PROGRESS'
    | 'MARK_AS_CLIENT_NO_SHOW'
    | 'ROOM_JOINED'
    | 'ROOM_LEFT'
    | 'SET_CLIENT_FEEDBACK_FORM_STATUS';
  payload?: any;
}

const meetingReducer = (state: MeetingState = initialMeetingState(), action: MeetingAction): MeetingState => {
  switch (action.type) {
    case 'SET_MEETING_INITIALIZED': {
      return { ...state, meetingInitialized: action.payload };
    }
    case 'MARK_AS_FINISHED': {
      return { ...state, sessionStatus: 'FINISHED' };
    }
    case 'LOAD_BOOKING_SUCCESS': {
      return {
        ...state,
        sessionStatus: action.payload?.sessionStatus,
        bookedTime: new Date(action.payload?.bookedTime),
        bookingId: action.payload?.id,
        clientPictureSrc: (action.payload as Booking)?.client?.avatar,
        healerPictureSrc: (action.payload as Booking)?.healer?.avatar,
        healerFirstName: (action.payload as Booking)?.healer?.firstName,
        healerLastName: (action.payload as Booking)?.healer?.lastName,
        clientFirstName: (action.payload as Booking)?.client?.firstName,
        clientLastName: (action.payload as Booking)?.client?.lastName,
        healerInitials: (action.payload as Booking)?.healer?.firstName?.charAt(0) || '' + (action.payload as Booking)?.healer?.lastName?.charAt(0),
        clientInitials: (action.payload as Booking)?.client?.firstName?.charAt(0) || '' + (action.payload as Booking)?.client?.lastName?.charAt(0),
        clientId: (action.payload as Booking)?.client?.id,
        healerId: (action.payload as Booking)?.healer?.id,
      };
    }
    case 'LOAD_BOOKING_FAILURE': {
      return { ...state, loadingDataErrors: state.loadingDataErrors.concat(extractMessageFromError(action.payload)) };
    }
    case 'MARK_AS_MEETING_IN_PROGRESS': {
      return { ...state, sessionStatus: 'MEETING_IN_PROGRESS' };
    }
    case 'MARK_AS_CLIENT_NO_SHOW': {
      return { ...state, sessionStatus: 'CLIENT_NO_SHOW' };
    }
    case 'ROOM_JOINED': {
      return { ...state, roomJoined: true };
    }
    case 'ROOM_LEFT': {
      return { ...state, roomJoined: false };
    }
    case 'SET_CLIENT_FEEDBACK_FORM_STATUS': {
      return { ...state, clientFeedbackFormStatus: action.payload };
    }
    default:
      return state;
  }
};

export default meetingReducer;
